import { Pages } from "./Pages";

export class Categories extends Pages {
    async init() {
        this.render(this.template({}), null);
    }
}